import {
  assoc,
  curry,
  dissoc,
  isEmpty,
  isNil,
  prop
} from 'ramda'

import config from 'config'

const logEnabled = config.ENV !== 'PRODUCTION'
const throwOnError = config.ENV !== 'PRODUCTION'

export const pause = async (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const delay = async (fn, ms) => {
  await pause(ms)
  await fn()
}

export const rename = curry((a, b, obj) => dissoc(a, assoc(b, prop(a, obj), obj)))

export const openSidebar = () => {
  if (typeof window.drift === 'undefined' || window.drift === null) { return }
  return window.drift.on('ready', api => api.sidebar.open())
}

export const generateQueryString = (stringArray, query) => {
  return stringArray.map((string, i) => {
    if (i === 0) {
      return `?${query}=${string}`
    }

    return `&${query}=${string}`
  })
}

export const isNilOrEmpty = (obj) => {
  return isNil(obj) || isEmpty(obj)
}

export const log = ({
  type = 'log',
  data
}) => {
  // eslint-disable-next-line
  logEnabled && console[type](`${config.APP_NAMESPACE}::`, ...data)
}

export const isObject = val => typeof val === 'object' && val !== null
export const isFunction = obj => !!(obj && obj.constructor && obj.call && obj.apply)


export const error = (e, dat) => {
  const error = (e instanceof Error)
    ? e
    : new Error(e)

  const errorHandler = err => {
    if(throwOnError){
      throw err
    } else {
      log({
        type: 'warn',
        data: [err.message]
      })
    }
  }

  errorHandler(error)
}
